/* Muse Aria -- ma-shop.js
   (A) Sold-out "Notify me": a GM popup with its own email capture. Submissions
       go through Shopify's newsletter signup (/contact), tagged so the restock
       list syncs to Omnisend and we know which product was requested.
   (B) Footer "Subscribe": slide-in drawer.
   Plus the mobile buy-bar: keep its label in sync with the *visible* submit
   button (pre-order / sold-out aware) and route its click correctly. */
(function () {
  'use strict';
  function el(tag, cls) { var e = document.createElement(tag); if (cls) e.className = cls; return e; }
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  /* The visible add-to-cart submit button. A pre-order app (gPreorder) hides the
     original .product-form__submit ("Add to cart") and shows its own visible
     "Pre Order" button, so prefer the visible / non-hidden one. */
  function effectiveAtc() {
    var btns = [].slice.call(document.querySelectorAll('.product-form__submit'));
    var vis = btns.filter(function (b) { return b.offsetParent !== null && !b.classList.contains('gPreorderHidden'); });
    return vis[0] || btns.filter(function (b) { return !b.classList.contains('gPreorderHidden'); })[0] || btns[0] || null;
  }
  function preorderBtn() {
    var b = document.querySelector('.product-form__submit.gPreorderBtn, .product-form__submit.gPreorderBtnLoaded');
    return (b && b.offsetParent !== null) ? b : null;
  }

  /* ================= (A) NOTIFY ME ================= */
  var nOverlay, nModal, nBuilt = false;

  function buildNotify() {
    if (nBuilt) return;
    nBuilt = true;
    nOverlay = el('div', 'ma-modal-overlay ma-notify-overlay');
    nModal = el('div', 'ma-modal ma-notify-modal');
    nModal.innerHTML =
      '<button type="button" class="ma-modal-close" aria-label="Close">✕</button>' +
      '<h2 class="ma-modal-title">Notify me when back in stock</h2>' +
      '<p class="ma-modal-sub">Leave your email and we’ll let you know the moment it returns.</p>' +
      '<form class="ma-sub-form ma-notify-form" novalidate>' +
        '<input type="email" name="email" class="ma-sub-input" placeholder="Email address" required autocomplete="email">' +
        '<button type="submit" class="ma-sub-submit">Notify me</button>' +
      '</form>' +
      '<p class="ma-sub-msg ma-notify-msg" hidden></p>';
    document.body.appendChild(nOverlay);
    document.body.appendChild(nModal);
    nOverlay.addEventListener('click', closeNotify);
    nModal.querySelector('.ma-modal-close').addEventListener('click', closeNotify);
    nModal.querySelector('.ma-notify-form').addEventListener('submit', submitNotify);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeNotify(); closeSub(); } });
  }
  function openNotify(e) {
    if (e && e.preventDefault) e.preventDefault();
    buildNotify();
    nOverlay.classList.add('is-open');
    nModal.classList.add('is-open');
    document.body.classList.add('ma-modal-lock');
  }
  function closeNotify() {
    if (!nBuilt) return;
    nOverlay.classList.remove('is-open');
    nModal.classList.remove('is-open');
    if (!document.querySelector('.ma-sub-drawer.is-open')) document.body.classList.remove('ma-modal-lock');
  }
  function submitNotify(e) {
    e.preventDefault();
    var form = e.target;
    var input = form.querySelector('input[type="email"]');
    var email = (input.value || '').trim();
    var msg = nModal.querySelector('.ma-notify-msg');
    if (!email || email.indexOf('@') === -1) { input.focus(); return; }
    var handle = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1] || '';
    var fd = new FormData();
    fd.append('form_type', 'customer');
    fd.append('utf8', '✓');
    fd.append('contact[email]', email);
    fd.append('contact[tags]', 'notify-back-in-stock' + (handle ? ', ' + handle : ''));
    fd.append('contact[accepts_marketing]', 'true');
    var btn = form.querySelector('.ma-sub-submit');
    if (btn) { btn.disabled = true; btn.textContent = 'Submitting…'; }
    fetch('/contact', { method: 'POST', body: fd, headers: { 'Accept': 'text/html' } })
      .then(function () { form.style.display = 'none'; msg.hidden = false; msg.textContent = 'Thanks — we’ll email you the moment it’s back.'; })
      .catch(function () { if (btn) { btn.disabled = false; btn.textContent = 'Notify me'; } msg.hidden = false; msg.textContent = 'Something went wrong. Please try again.'; });
  }
  window.maOpenNotify = openNotify;

  function isSoldOut(atc) {
    return !!(atc && (atc.disabled || /sold out|unavailable|notify/i.test((atc.textContent || ''))));
  }

  /* Desktop: replace the disabled Add-to-Cart with a Notify Me button. */
  function initPDP() {
    if (location.pathname.indexOf('/products/') === -1) return;
    document.body.classList.add('ma-has-notify-embed');
    var wrap = document.querySelector('.product-form__buttons');
    if (!wrap) return;
    var atc = wrap.querySelector('.product-form__submit');
    var myBtn = wrap.querySelector('.ma-notify-btn');
    if (isSoldOut(atc)) {
      if (!myBtn) {
        myBtn = el('button', 'ma-notify-btn');
        myBtn.type = 'button';
        myBtn.textContent = 'Notify me';
        myBtn.addEventListener('click', openNotify);
        wrap.appendChild(myBtn);
      }
      myBtn.style.display = '';
      if (atc) atc.style.display = 'none';
    } else {
      if (myBtn) myBtn.style.display = 'none';
      if (atc) atc.style.display = '';
    }
  }

  /* Mobile sticky bar: mirror the visible submit button's label (pre-order shows
     "Pre Order", sold-out shows "Notify me"), kept in place against the cart script. */
  function watchBuybar() {
    var bar = document.querySelector('.ma-buybar');
    if (!bar) return false;
    var btn = bar.querySelector('.ma-buybar-btn');
    if (!btn) return false;
    function fix() {
      if (btn.hasAttribute('data-soldout')) { if (btn.textContent.trim().toLowerCase() !== 'notify me') btn.textContent = 'Notify me'; return; }
      var atc = effectiveAtc();
      var t = atc ? (atc.textContent || '').replace(/\s+/g, ' ').trim() : '';
      if (t && btn.textContent.trim() !== t) btn.textContent = t;
    }
    fix();
    try { new MutationObserver(fix).observe(btn, { childList: true, characterData: true, subtree: true, attributes: true }); } catch (e) {}
    return true;
  }

  /* Reveal the sticky bar only after the on-page Add-to-Cart button scrolls out
     of view (above the viewport). Mobile only via the CSS transform. */
  function initBuybarScroll() {
    if (location.pathname.indexOf('/products/') === -1) return;
    var target = document.querySelector('.product-form__buttons') || document.querySelector('.product-form__submit');
    if (!target || target.__maScroll) return;
    target.__maScroll = 1;
    function update() {
      var r = target.getBoundingClientRect();
      document.body.classList.toggle('ma-atc-passed', r.bottom < 8);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* Buy-bar click routing (capture phase so it runs before the bar's own
     atc.click() handler): sold-out -> Notify popup; pre-order -> click the real
     "Pre Order" button so the pre-order line-item property is added. Normal adds
     fall through to the bar's default handler. */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('.ma-buybar-btn') : null;
    if (!t) return;
    if (t.hasAttribute('data-soldout')) { e.preventDefault(); e.stopImmediatePropagation(); openNotify(); return; }
    var pre = preorderBtn();
    if (pre) { e.preventDefault(); e.stopImmediatePropagation(); pre.click(); }
  }, true);

  /* ================= (B) SUBSCRIBE DRAWER ================= */
  var sOverlay, sDrawer, sBuilt = false;
  function buildSub() {
    if (sBuilt) return;
    sBuilt = true;
    sOverlay = el('div', 'ma-modal-overlay ma-sub-overlay');
    sDrawer = el('aside', 'ma-sub-drawer');
    sDrawer.setAttribute('aria-label', 'Subscribe');
    sDrawer.innerHTML =
      '<button type="button" class="ma-modal-close" aria-label="Close">✕</button>' +
      '<h2 class="ma-sub-title">Subscribe</h2>' +
      '<p class="ma-sub-text">Be the first to know about new drops and get invitations to events.</p>' +
      '<form class="ma-sub-form" novalidate>' +
        '<input type="email" name="email" class="ma-sub-input" placeholder="Email address" required autocomplete="email">' +
        '<button type="submit" class="ma-sub-submit">Subscribe</button>' +
      '</form>' +
      '<p class="ma-sub-msg" hidden></p>';
    document.body.appendChild(sOverlay);
    document.body.appendChild(sDrawer);
    sOverlay.addEventListener('click', closeSub);
    sDrawer.querySelector('.ma-modal-close').addEventListener('click', closeSub);
    sDrawer.querySelector('.ma-sub-form').addEventListener('submit', submitSub);
  }
  function openSub(e) {
    if (e && e.preventDefault) e.preventDefault();
    buildSub();
    sOverlay.classList.add('is-open');
    sDrawer.classList.add('is-open');
    document.body.classList.add('ma-modal-lock');
  }
  function closeSub() {
    if (!sBuilt) return;
    sOverlay.classList.remove('is-open');
    sDrawer.classList.remove('is-open');
    if (!document.querySelector('.ma-notify-modal.is-open')) document.body.classList.remove('ma-modal-lock');
  }
  function submitSub(e) {
    e.preventDefault();
    var form = e.target;
    var input = form.querySelector('.ma-sub-input');
    var email = (input.value || '').trim();
    var msg = sDrawer.querySelector('.ma-sub-msg');
    if (!email || email.indexOf('@') === -1) { input.focus(); return; }
    var fd = new FormData();
    fd.append('form_type', 'customer');
    fd.append('utf8', '✓');
    fd.append('contact[email]', email);
    fd.append('contact[tags]', 'newsletter');
    fd.append('contact[accepts_marketing]', 'true');
    var btn = form.querySelector('.ma-sub-submit');
    if (btn) { btn.disabled = true; btn.textContent = 'Subscribing…'; }
    fetch('/contact', { method: 'POST', body: fd, headers: { 'Accept': 'text/html' } })
      .then(function () { form.style.display = 'none'; msg.hidden = false; msg.textContent = 'Thanks — you’re subscribed.'; })
      .catch(function () { if (btn) { btn.disabled = false; btn.textContent = 'Subscribe'; } msg.hidden = false; msg.textContent = 'Something went wrong. Please try again.'; });
  }
  window.maOpenSubscribe = openSub;

  function initFooterSub() {
    var footer = document.querySelector('.shopify-section-group-footer-group') || document.querySelector('footer');
    if (!footer) return;
    var found = false;
    [].forEach.call(footer.querySelectorAll('a, button'), function (a) {
      if (/^\s*subscribe\s*$/i.test(a.textContent || '')) {
        found = true;
        if (!a.__maSub) { a.__maSub = 1; a.addEventListener('click', openSub); }
      }
    });
    if (found) return;
    var nav = footer.querySelector('.ma-foot-nav');
    if (!nav || nav.querySelector('.ma-foot-subscribe')) return;
    var link = el('a', 'ma-foot-link ma-foot-subscribe');
    link.href = '#';
    link.textContent = 'Subscribe';
    link.addEventListener('click', openSub);
    var links = nav.querySelectorAll('a.ma-foot-link'), anchor = null;
    for (var i = 0; i < links.length; i++) { if (/store locator|legal notice/i.test(links[i].textContent)) anchor = links[i]; }
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(link, anchor.nextSibling);
    else nav.appendChild(link);
  }

  /* (C) Mobile GM-style search bar injected directly beneath the hero on the
     homepage. A real typable field; submitting it opens the full-screen search
     drawer with the query. Visibility is mobile-only via CSS. */
  var HSEARCH_TERMS = ['Mars 2.0', 'Aria', 'Noa', 'Mira', 'Rachel'];
  function initMobileHeroSearch() {
    var p = location.pathname;
    if (p !== '/' && p !== '' && p !== '/index') return;
    if (document.querySelector('.ma-hsearch-wrap')) return;
    var hero = document.querySelector('.ma-hero');
    if (!hero) return;
    var sec = hero.closest('.shopify-section') || hero;
    var wrap = el('div', 'ma-hsearch-wrap');
    /* A real, typable search field. Submitting it (Enter / the phone keyboard's
       "search" key / tapping the magnifier) opens the same full-screen search
       drawer used by the header icon, carrying the typed query across. */
    var form = el('form', 'ma-hsearch');
    form.setAttribute('role', 'search');
    form.setAttribute('action', '/search');
    form.innerHTML =
      '<button type="submit" class="ma-hsearch-go" aria-label="Search">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><path d="M21 21l-4.3-4.3"></path></svg>' +
      '</button>' +
      '<input class="ma-hsearch-input" type="search" name="q" autocomplete="off" enterkeyhint="search" aria-label="Search">';
    wrap.appendChild(form);
    sec.parentNode.insertBefore(wrap, sec.nextSibling);

    var input = form.querySelector('.ma-hsearch-input');
    var i = 0, typed = false;
    input.placeholder = HSEARCH_TERMS[0];
    /* Rotate the placeholder until the shopper starts typing. */
    var rot = setInterval(function () {
      if (typed) { clearInterval(rot); return; }
      input.classList.add('is-out');
      setTimeout(function () {
        i = (i + 1) % HSEARCH_TERMS.length;
        if (!typed) { input.placeholder = HSEARCH_TERMS[i]; }
        input.classList.remove('is-out');
      }, 350);
    }, 2800);

    input.addEventListener('input', function () {
      typed = input.value.length > 0;
      if (!typed) { input.placeholder = HSEARCH_TERMS[i]; }
    });

    function openDrawer(q) {
      var toggle = document.querySelector('.header__search summary, .header__search .header__icon--search, .header__icon--search');
      if (toggle) { toggle.click(); }
      setTimeout(function () {
        var inp = document.querySelector('.search-modal__content input[type="search"], .search-modal__content .search__input');
        if (inp) {
          inp.value = q;
          inp.focus();
          inp.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }, 140);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = (input.value || '').trim() || HSEARCH_TERMS[i];
      input.blur();
      openDrawer(q);
      input.value = '';
      typed = false;
    });
  }

  /* (D) Mobile menu drawer: tag the "View all" links so they read as a secondary
     action rather than another category -- mirrors the desktop mega-menu, where
     View All is small, underlined and muted. CSS can't match on text, so we tag. */
  function initDrawerViewAll() {
    var drawer = document.querySelector('.menu-drawer');
    if (!drawer) return;
    [].forEach.call(drawer.querySelectorAll('.menu-drawer__menu-item'), function (a) {
      if (a.__maVA) return;
      var t = (a.textContent || '').replace(/\s+/g, ' ').trim();
      if (/^view all$/i.test(t)) { a.__maVA = 1; a.classList.add('ma-menu-viewall'); }
    });
  }

  ready(function () {
    initFooterSub();
    initMobileHeroSearch();
    initDrawerViewAll();
    var tries = 0;
    var iv = setInterval(function () { initPDP(); watchBuybar(); initBuybarScroll(); initFooterSub(); initMobileHeroSearch(); initDrawerViewAll(); if (++tries > 30) clearInterval(iv); }, 250);
    document.addEventListener('change', function () { setTimeout(initPDP, 300); });
    /* The drawer's submenus render on open, so re-tag on interaction too. */
    document.addEventListener('click', function () { setTimeout(initDrawerViewAll, 120); });
  });
})();
